import API from "./index"

export const getMembers = (team) => API.get(`/members/${team}`)
export const createMember = (data) => API.post(`/members`, data)
export const deleteMember = (id) => API.delete(`/members/${id}`)